import fetchUserThemes from '../api/fetchUserThemes';

const fetchThemeIdByName = async (themeName: string): Promise<string | null> => {
  try {
    const { themes } = await fetchUserThemes();
    const matched = themes.find((theme) => theme.themeName === themeName);
    return matched?.themeId ?? null;
  } catch (err) {
    console.error('Error fetching theme ID:', err);
    return null;
  }
};

export default fetchThemeIdByName;
